const accessibility_btn = document.querySelector('.skip-to-content-link');
accessibility_btn.addEventListener('focus',function(){
    this.classList.remove('visually-hidden');
});

accessibility_btn.addEventListener('blur',function(){
    this.classList.add('visually-hidden');
});

$(document).ready(function(){

  $('.header-menu__item--has-sublinks').hover(function(){
    $(this).children('button').attr('aria-expanded','true');
  },function(){
    $(this).children('button').attr('aria-expanded','false');
  });
  
  const formPresent = $('.globo-app-extension');
  if(formPresent.length > 0){
    const findForm = setInterval(function(){
      $(formPresent).each(function(){
      const form = $(this).find('form');
        form.wrapInner('<fieldset></fieldset>');
        const formType = form.closest('.globo-form');
        if(formType.hasClass('farmer-recruitment-form')){
          form.find('fieldset').prepend('<legend>Farmer Recruitment Form</legend>');
        }
         if(formType.hasClass('contact-form')){
          form.find('fieldset').prepend('<legend>Contact Form</legend>');
        }
         if(formType.hasClass('job-application-form')){
          form.find('fieldset').prepend('<legend>Job Application Form</legend>');
        }
        const radios = form.find('.globo-form-control[data-type=radio]');
        radios.each(function(){
          $(this).wrapInner('<fieldset></fieldset>');
          const label = $(this).find('.label-content').attr('data-label');
          $(this).find('fieldset').prepend('<legend>'+label+'</legend>');
        });
        const labels = form.find('label');
        labels.each(function(){
          const labelText = $(this).find('.label-content').html();  
          if(typeof labelText != 'undefined'){
            if(labelText.toLowerCase().indexOf('name') > -1){
            
             $(this).next('.globo-form-input').find('input').attr('autocomplete','name');
            $(this).next('.globo-form-input').find('textarea').attr('autocomplete','name');
            $(this).next('.globo-form-input').find('select').attr('autocomplete','name');

          }
          if(labelText.toLowerCase().indexOf('city') > -1){
             $(this).next('.globo-form-input').find('input').attr('autocomplete','address-level2');
            $(this).next('.globo-form-input').find('textarea').attr('autocomplete','address-level2');
            $(this).next('.globo-form-input').find('select').attr('autocomplete','address-level2');
          }
          if(labelText.toLowerCase().indexOf('state') > -1){
             $(this).next('.globo-form-input').find('input').attr('autocomplete','address-level1');
            $(this).next('.globo-form-input').find('textarea').attr('autocomplete','address-level1');
            $(this).next('.globo-form-input').find('select').attr('autocomplete','address-level1');
          }
          if(labelText.toLowerCase().indexOf('email') > -1){
             $(this).next('.globo-form-input').find('input').attr('autocomplete','email');
            $(this).next('.globo-form-input').find('textarea').attr('autocomplete','email');
            $(this).next('.globo-form-input').find('select').attr('autocomplete','email');
          }
             if(labelText.toLowerCase().indexOf('phone') > -1){
             $(this).next('.globo-form-input').find('input').attr('autocomplete','tel');
            $(this).next('.globo-form-input').find('textarea').attr('autocomplete','tel');
            $(this).next('.globo-form-input').find('select').attr('autocomplete','tel');
          }
          }
          
          const lastSpan = $(this).find('span:last-of-type');
      
          if(typeof lastSpan == 'object' && typeof lastSpan.html() != 'undefined' && lastSpan.html().indexOf('*') > -1){

            $(this).next('.globo-form-input').find('input').attr('required',true);
            $(this).next('.globo-form-input').find('textarea').attr('required',true);
            $(this).next('.globo-form-input').find('select').attr('required',true);
          }
          
        });
      form.find('.wizard__submit').click(function(){
        const errorCheck = setInterval(function(){
          const hasErrors = form.find('.errors');
        if(hasErrors.length > 0){
       
          const errorChecker = setInterval(function(){
         const formFields = $('.globo-form-control');
            formFields.each(function(){
              if($(this).hasClass('has-error')){
                $(this).find('input').attr('aria-invalid',true);
                $(this).find('textarea').attr('aria-invalid',true);
                $(this).find('select').attr('aria-invalid',true);
  
                let message = $(this).find('.help-block.error').html();
                const label = $(this).find('.label-content').html();
                message = message + ' for ' + label;
                $(this).find('input').attr('aria-alert',message);
                $(this).find('textarea').attr('aria-alert',message);
                $(this).find('select').attr('aria-alert',message);
              }else{
                $(this).find('input').removeAttr('aria-invalid');
                $(this).find('textarea').removeAttr('aria-invalid');
                $(this).find('select').removeAttr('aria-invalid');
                 $(this).find('input').removeAttr('aria-alert');
                $(this).find('textarea').removeAttr('aria-alert');
                $(this).find('select').removeAttr('aria-alert');
              }
            });
          },500);
          clearInterval(errorCheck);
        } 
        },500);        
      });
    });
      clearInterval(findForm);
  },500);
    }
    

  const images = $('img');

  images.each(function(){
    if(!$(this).attr('alt')){
      $(this).attr('alt',"");
    }
  });
  
  $('.blog-card').click(function(e){
    const blog_link = $(this).attr('data-linkto');
    if(blog_link){
      location.href=blog_link;
    }
  });

  const globoInt = setInterval(function(){
    if($('.globo-formbuilder-wizard').length > 0){
      $('label').each(function(){
        $(this).removeAttr('tabindex');
      });
      clearInterval(globoInt);
    }
  },500);
  


  $(document).on('keypress','.keyboard-events',function(e){
    if(e.key === 'Enter' || e.key === ' '){
      const link = $(this).attr('data-linkto');
      if(link){
        location.href=link;
      }
    }
  });
  
  function preventOutsideFocus(element,firstFocus,lastFocus){
    element.on('keydown', function(e) {
    if(e.target == firstFocus[0] && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocus[0].focus();
  
    } else if(e.target == lastFocus[0] && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocus[0].focus();
  
    }
  });
  }


  preventOutsideFocus($('#offCanvasMenu'),$('#offCanvasMenu button.close'),$('#offCanvasMenu .offcanvas-menu__sticky-item a.button'));

  $(document).on('closed.zf.offCanvas', '#offCanvasMenu', function () {
  $('.mobile-menu-trigger').focus();

  
});
  let resultsList = 0;
 
  $('#search-input').on('keydown',function(e){
    let focusedObject = $('.focused');
    const openStatus = $('#search-input').attr('aria-expanded') === 'true';
     const resultsLists = [];
    $('.search-results-section').each(function(){
      const list = $(this);
      if($(this).find('.media-object').length > 0){
        resultsLists.push('#'+list.attr('id'));
      }
    });
    
    let nextObject = [];
  let prevObject = [];
    if(openStatus && e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)){
      resultsList = resultsList < 0 ? 0 : resultsList;
      e.preventDefault();
      if(focusedObject.length > 0){
        nextObject = focusedObject.next();
        if(nextObject.length > 0){
          focusedObject.removeClass('focused');
          nextObject.addClass('focused');
          return;
        }else{
          resultsList = resultsLists.length - 1 >= resultsList ? resultsList + 1 : resultsList;
          if(resultsLists.length - 1 >= resultsList){
            focusedObject.removeClass('focused');
            $(resultsLists[resultsList]).find('.media-object').first().addClass('focused');
            return;
          }else{
            focusedObject.removeClass('focused');
            $('.link__view-all').addClass('focused');
            return;
          }
        }
        return;
      }else{
        $(resultsLists[resultsList]).find('.media-object').first().addClass('focused');
        return;        
      }
    }else if(openStatus && e.key === 'ArrowUp' || (e.key === 'Tab' && e.shiftKey)){
      e.preventDefault();
      if(focusedObject.length > 0){
        prevObject = focusedObject.prev();
        if(prevObject.length > 0){
          focusedObject.removeClass('focused');
          prevObject.addClass('focused');
          return;
        }else{
          resultsList = resultsList >= 0 ? resultsList - 1 : resultsList;
          if(resultsList >= 0 && resultsLists.length - 1 >= resultsList){
            focusedObject.removeClass('focused');
            $(resultsLists[resultsList]).find('.media-object').last().addClass('focused');
            return;
          }else{
            focusedObject.removeClass('focused');
            $('#search-results').fadeOut().attr("aria-expanded","false");
           $('#search-input').attr("aria-expanded","false");
            return;
          }
        }
        return;
      }else{
          
        return;        
      }
    }else if(openStatus && e.key === 'Escape'){
      e.preventDefault();
      focusedObject.removeClass('focused');
      $('#search-results').fadeOut().attr("aria-expanded","false");
     $('#search-input').attr("aria-expanded","false");
      return;
    }
  });
  
});
